const c = {
  name: "Gambling2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,18.6l3.3-3.3l1.4,1.4L21.4,20l3.3,3.3l-1.4,1.4L20,21.4l-3.3,3.3l-1.4-1.4l3.3-3.3l-3.3-3.3l1.4-1.4
			L20,18.6z"/>
		<path class="st0" d="M20,0C14.5,0,9.5,2.2,5.9,5.9C2.2,9.5,0,14.5,0,20c0,5.5,2.2,10.5,5.9,14.1C9.5,37.8,14.5,40,20,40
			c5.5,0,10.5-2.2,14.1-5.9C37.8,30.5,40,25.5,40,20c0-5.5-2.2-10.5-5.9-14.1C30.5,2.2,25.5,0,20,0z M12.2,10.8L8,6.6
			C11,3.9,14.8,2.3,19,2v6C16.4,8.3,14.1,9.3,12.2,10.8z M10.8,12.2C9.3,14.1,8.3,16.4,8,19H2c0.2-4.2,1.9-8,4.6-11L10.8,12.2z
			 M8,21c0.2,2.6,1.2,4.9,2.8,6.8L6.6,32C3.9,29,2.3,25.2,2,21H8z M19,38c-4.2-0.2-8-1.9-11-4.6l4.2-4.2c1.9,1.6,4.2,2.6,6.8,2.8V38
			z M21,32c2.6-0.2,4.9-1.2,6.8-2.8l4.2,4.2c-2.9,2.6-6.8,4.3-11,4.6V32z M29.2,27.8c1.6-1.9,2.6-4.2,2.8-6.8h6
			c-0.2,4.2-1.9,8-4.6,11L29.2,27.8z M32,19c-0.2-2.6-1.2-4.9-2.8-6.8L33.4,8c2.6,2.9,4.3,6.8,4.6,11H32z M27.8,10.8
			C25.9,9.3,23.6,8.3,21,8V2c4.2,0.2,8,1.9,11,4.6L27.8,10.8z M12.9,12.9c1.8-1.8,4.3-2.9,7.1-2.9c2.8,0,5.3,1.1,7.1,2.9
			c1.8,1.8,2.9,4.3,2.9,7.1c0,2.8-1.1,5.3-2.9,7.1C25.3,28.9,22.8,30,20,30c-2.8,0-5.3-1.1-7.1-2.9S10,22.8,10,20
			C10,17.2,11.1,14.7,12.9,12.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Gambling2
};
